import {
  sendGoogleEvent,
  parameters,
  smoothScroll,
  sendRequest,
  byUserInteraction,
} from '@html/_common/utils';

import AOTourRateTranslation from '@atomic/organisms/_common/rate-translation';

export default class ReviewsSection {
  constructor(
    tdpEventCategory,
    tourId,
    imageGalleryLightboxManager,
  ) {
    this.TDP_EVENT_CATEGORY = tdpEventCategory;
    this.tourId = tourId;
    this.eventAction = 'Reviews Section';
    this.imageGalleryLightboxManager = imageGalleryLightboxManager;

    this.REVIEWS_CONTAINER_SELECTOR = '.js-ao-tour-reviews__review-container';
    this.SHOW_MORE_TEXT_SELECTOR = '.js-aa-tour-reviews__review-show-more';
    this.REVIEW_BUTTONS_CONTAINER_SELECTOR = '.js-aa-tour-reviews__review-button-container';
    this.REVIEW_ITEM_SELECTOR = '.js-ao-tour-reviews__review-item';
    this.REVIEW_BODY_SELECTOR = '.js-am-tour-reviews__review-item-body';
    this.VOTE_BUTTON_SELECTOR = '.js-aa-tour-reviews__review-button--thumb';
    this.VOTE_COUNT_SELECTOR = '.js-aa-tour-reviews__review-button--thumb-count';
    this.LOAD_MORE_SELECTOR = '.js-ao-tour-reviews__load-more-cta';
    this.SORT_SELECTOR = '.js-ao-tour-reviews__sorting-item';
    this.OVERVIEW_LINK_SELECTOR = '.js-ao-tour-reviews__overview-list-item-link';

    this.REVIEWS_CONTAINER_LOAD_SELECTOR = 'ao-tour-reviews__review-container--loading';
    this.REVIEW_HIDDEN_CLASS = 'ao-tour-reviews__review-item--hidden';
    this.SORT_ACTIVE_CLASS = 'ao-tour-reviews__sorting-item--active';

    this.REVIEWS_INITIALLY_VISIBLE = 5;

    this.page = 1;
    this.shouldBeFullyReloaded = 0;
    this.reviewsPerPage = parameters.reviewsPerPage;
    this.onpage = 0;
    this.sort = 'recent';
    this.isMobileOrTablet = $(window).width() <= 1023;
    this.numberOfDisplayedReviews = 0;

    this.$reviewsContainer = $(this.REVIEWS_CONTAINER_SELECTOR);
    this.$loadMoreReviewsButton = $(this.LOAD_MORE_SELECTOR);

    this.reviews = {
      original: [],
      translated: [],
    };
  }

  initiate() {
    this.onpage = parseInt(this.$reviewsContainer.data('onpage'), 10);
    this.numberOfDisplayedReviews = this.onpage;

    this.initReviewButtons();

    this.initVotes();

    this.initReadMoreText();

    this.initImageFunctionality();

    this.initLoadMore();

    this.initSorting();

    this.initiateOverview();

    this.initTranslations();

    this.initReviewOverflow();

    this.initHideReviews(this.REVIEWS_INITIALLY_VISIBLE);
  }

  sendEvent(label, ampEventParams = {}) {
    sendGoogleEvent(
      this.TDP_EVENT_CATEGORY,
      this.eventAction,
      label || '',
      ampEventParams,
    );
  }

  initTranslations() {
    this.$reviewsContainer.on('click', '.translate-link', (event) => {
      const link = $(event.currentTarget);
      const $reviewItem = link.parents(this.REVIEW_ITEM_SELECTOR);
      if (link.parent('.translated-block').hasClass('original')) {
        $reviewItem.data('original', 0);
        this.reloadReviewText($reviewItem);

        $reviewItem.find('.translated-block.translated').removeClass('hid');
        $reviewItem.find('.translated-block.original').addClass('hid');

        sendGoogleEvent(
          this.TDP_EVENT_CATEGORY,
          'Reviews',
          'Translate',
        );
      } else {
        $reviewItem.data('original', 1);
        this.reloadReviewText($reviewItem);

        $reviewItem.find('.translated-block.translated').addClass('hid');
        $reviewItem.find('.translated-block.original').removeClass('hid');

        sendGoogleEvent(
          this.TDP_EVENT_CATEGORY,
          'Reviews',
          'Show original',
        );
      }
    });

    const rateTranslation = new AOTourRateTranslation(null, this.$reviewsContainer);
    rateTranslation.initiate();
  }

  reloadReviewText($reviewItem) {
    const $reviewBody = $reviewItem.find(this.REVIEW_BODY_SELECTOR);
    const isOriginal = $reviewItem.data('original');
    const reviewId = $reviewItem.data('id');
    this.loadReviewTextById(reviewId, isOriginal, (text) => {
      $reviewBody.text(text);
    });
  }

  checkTextOverflow(element) {
    if ($(element)[0].clientHeight < $(element).prop('scrollHeight')) {
      $(element).parent().find(this.SHOW_MORE_TEXT_SELECTOR).removeClass('hid');
    }
  }

  checkReviewsOverflow() {
    const $truncateTexts = $(this.REVIEW_BODY_SELECTOR);
    if ($truncateTexts.length) {
      $truncateTexts.each((index, element) => {
        this.checkTextOverflow(element);
      });
    }
  }

  initReviewOverflow() {
    byUserInteraction('check-for-review-overflows', () => {
      this.checkReviewsOverflow();
    });
  }

  initiateOverview() {
    const $overviewLink = $(this.OVERVIEW_LINK_SELECTOR);

    $overviewLink.click(() => {
      this.sendEvent('Overview - Click');
    });
  }

  initSorting() {
    const $sortButtons = $(this.SORT_SELECTOR);

    if (!$sortButtons.length) {
      return;
    }

    $sortButtons.forEach((elem) => {
      if ($(elem).hasClass(this.SORT_ACTIVE_CLASS)) {
        this.sort = $(elem).data('sort');
      }
    });

    $sortButtons.click((event) => {
      const $clickedButton = $(event.currentTarget);

      if ($clickedButton.hasClass(this.SORT_ACTIVE_CLASS)) {
        return;
      }

      $sortButtons.removeClass(this.SORT_ACTIVE_CLASS);
      $clickedButton.addClass(this.SORT_ACTIVE_CLASS);

      this.sort = $clickedButton.data('sort');

      this.sendEvent(
        `Sort - ${this.sort}`,
        {
          ampEventName: 'tdp_reviews_clicked',
          tdp_reviews_clicked_sorting: `${this.sort}`,
        },
      );

      this.$reviewsContainer.addClass(this.REVIEWS_CONTAINER_LOAD_SELECTOR);

      this.page = 1;
      this.shouldBeFullyReloaded = 1;
      this.numberOfDisplayedReviews = 0;

      this.loadReviews(() => {
        this.$reviewsContainer.removeClass(this.REVIEWS_CONTAINER_LOAD_SELECTOR);
        if (this.isMobileOrTablet) {
          smoothScroll({
            to: $sortButtons,
            duration: 200,
          });
        }
      });
    });
  }

  initLoadMore() {
    this.$loadMoreReviewsButton.click(() => {
      this.$loadMoreReviewsButton.attr('disabled', true);

      this.sendEvent(
        'Show More Reviews - Click',
        {
          ampEventName: 'tdp_reviews_clicked',
          tdp_reviews_clicked_show_more: 'Yes',
        },
      );

      if (this.showHiddenReviews() === this.reviewsPerPage) {
        this.$loadMoreReviewsButton.removeAttr('disabled');
        this.checkIfTotalReviewsReached();
        return;
      }

      this.page += 1;

      this.loadReviews();
    });
  }

  loadReviews(callback) {
    sendRequest('/api/tour/load', {
      action: 'reviews_more',
      id: this.tourId,
      page: this.page,
      sort: this.sort,
      should_be_fully_reloaded: this.shouldBeFullyReloaded,
    }, (data) => {
      this.$loadMoreReviewsButton.removeAttr('disabled');

      if (data && data.status === 'OK') {
        if (this.page === 1) {
          this.$reviewsContainer.html(data.component);
          this.numberOfDisplayedReviews += this.reviewsPerPage;
        } else {
          this.$reviewsContainer.append(data.component);
          this.numberOfDisplayedReviews += this.reviewsPerPage;
        }
      }
      this.checkReviewsOverflow();
      this.checkIfTotalReviewsReached();

      if (callback) {
        callback();
      }
    });
  }

  showHiddenReviews() {
    let reviewsRevealed = 0;
    const $reviews = $(this.REVIEW_ITEM_SELECTOR);

    $reviews.forEach((elem) => {
      if (reviewsRevealed < this.reviewsPerPage && $(elem).hasClass(this.REVIEW_HIDDEN_CLASS)) {
        $(elem).removeClass(this.REVIEW_HIDDEN_CLASS);
        reviewsRevealed += 1;
        this.numberOfDisplayedReviews += 1;
      }
    });

    return reviewsRevealed;
  }

  initImageFunctionality() {
    $('.js-ao-tour-reviews').on('click', '.js-am-tour-reviews__review-open-photos', (event) => {
      event.preventDefault();
      const $clickTarget = $(event.currentTarget);

      if ($clickTarget.closest('.js-am-tour-reviews__review-open-photos').data('lightbox-created') === true) {
        return;
      }

      const $whichPhotoContainer = $clickTarget.closest('.js-am-tour-reviews__review-photos-container');
      const $imagesOfPhotoContainer = $whichPhotoContainer.find('.js-am-tour-reviews__review-open-photos');
      const galleryTitle = $whichPhotoContainer?.data('gallery-title') || 'Customer Photos';

      // Workaround to make lightbox work for review images:
      // we need a random class - since review images can be loaded with "load more" button
      // thus we get images with the same class
      const randomString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      const randomClass = `js-am-tour-reviews__review-open-photos${randomString}`;

      // add random class & data attribute that a lightbox has already been created
      $.each($imagesOfPhotoContainer, (i, imgEl) => {
        $(imgEl).addClass(randomClass);
        $(imgEl).data('lightbox-created', true);
      });

      const imageUrls = $.map($whichPhotoContainer.find('.js-am-tour-reviews__review-open-photos'), (el) => $(el).data('image-src'));

      this.imageGalleryLightboxManager.createNewImageGallery(imageUrls, {
        openElementSelector: `.${randomClass}`,
        startingIndex: (eventForOpenElementSelector) => parseInt($(eventForOpenElementSelector.currentTarget).data('image-index'), 10),
        callBackAfterCreation: () => {
          // after the lightbox has been created we click the target
          $clickTarget.click();
        },
        lowerResolutionImageSize: '720',
        higherResolutionImageSize: '1440',
        galleryTitle,
        googleEvents: {
          category: this.TDP_EVENT_CATEGORY,
          eventGalleryName: 'Traveller Photos',
          actionVariations: [
            {
              className: 'js-am-tour-reviews__review-open-photos',
              action: this.eventAction,
            },
          ],
        },
      });
    });
  }

  initReviewButtons() {
    const $reviewButtons = $(this.REVIEW_BUTTONS_CONTAINER_SELECTOR);

    if (!$reviewButtons.length) {
      return;
    }

    const reviewIds = [];
    $reviewButtons.each((index, element) => {
      reviewIds.push($(element).parents(this.REVIEW_ITEM_SELECTOR).data('id'));
    });

    byUserInteraction('reviewButtons', () => {
      this.loadReviewButtons(reviewIds);
    });
  }

  loadReviewButtons(ids) {
    if (!ids.length) {
      return;
    }

    sendRequest('/api/tour/load', {
      action: 'reviews_buttons',
      ids,
    }, (data) => {
      if (data && data.status === 'OK') {
        Object.keys(data.component).map((id) => {
          $(`${this.REVIEW_ITEM_SELECTOR}[data-id="${id}"] ${this.REVIEW_BUTTONS_CONTAINER_SELECTOR}`).html(data.component[id]);
          return true;
        });
      }
    });
  }

  initVotes() {
    this.$reviewsContainer.on('click', this.VOTE_BUTTON_SELECTOR, (event) => {
      const $target = $(event.currentTarget);
      const vote = $target.data('vote');
      const currentVote = parseInt($target.data('curr'), 10);
      const reviewId = $target.parents(this.REVIEW_ITEM_SELECTOR).data('id');

      sendRequest('/api/tour/load', {
        action: 'review_vote',
        id: reviewId,
        vote,
      }, (data) => {
        if (data && data.status === 'OK') {
          $target.find(this.VOTE_COUNT_SELECTOR).html(currentVote + 1);

          this.sendEvent(
            `Vote - ${vote}`,
            {
              ampEventName: 'tdp_reviews_clicked',
              tdp_reviews_clicked_vote: `${vote}`,
            },
          );
        } else {
          window.alert('You already voted for this review.'); // eslint-disable-line no-alert
        }
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  loadReviewTextById(reviewId, isOriginal, callback) {
    sendRequest('/api/tour/load', {
      action: 'review_text',
      id: reviewId,
      original: isOriginal,
    }, (data) => {
      if (data && data.status === 'OK') {
        callback(data.text);
      }
    });
  }

  initReadMoreText() {
    this.$reviewsContainer.on('click', this.SHOW_MORE_TEXT_SELECTOR, (event) => {
      event.preventDefault();
      const $target = $(event.currentTarget);
      const $reviewItem = $target.parents(this.REVIEW_ITEM_SELECTOR);
      const $targetParent = $target.parent();
      const fullText = $targetParent.data('text');

      if (fullText) {
        $targetParent.text(fullText);
      } else if ($reviewItem.find(this.REVIEW_BODY_SELECTOR).hasClass('am-tour-reviews__review-item-body-text--truncated')) {
        $reviewItem.find(this.REVIEW_BODY_SELECTOR).removeClass('am-tour-reviews__review-item-body-text--truncated');
      } else {
        this.reloadReviewText($reviewItem);
      }

      $target.remove();

      this.sendEvent('Show More Text');
    });
  }

  checkIfTotalReviewsReached() {
    const total = this.$reviewsContainer.data('total');
    const isLastReviewPageReached = this.numberOfDisplayedReviews >= total;

    if (isLastReviewPageReached) {
      this.$loadMoreReviewsButton.hide();
    } else {
      this.$loadMoreReviewsButton.show();
    }
  }

  initHideReviews(max) {
    byUserInteraction('hideReviews', () => {
      $(this.REVIEW_ITEM_SELECTOR).forEach((elem) => {
        const number = parseInt($(elem).data('number'), 10);
        if (number > max) {
          $(elem).addClass(this.REVIEW_HIDDEN_CLASS);
        }
      });
    });
  }
}
